import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { BlockShell } from './_shared';

// Compliance: Zertifikat-Badges (ISO, ATEX, RoHS …), nur wenn vorhanden.
const BlockCompliance = ({ dto, t, isDarkMode }) => {
  const comp = dto.compliance || {};
  const items = comp.items || [];

  return (
    <BlockShell title={t('productDetail.compliance')} icon={ShieldCheck} status={comp.status} isDarkMode={isDarkMode} demoLabel={t('productDetail.demoFromSap')}>
      <div className="flex flex-wrap gap-2">
        {items.map((c, i) => (
          <span key={i} className="inline-flex items-center text-xs px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
            {c.label}
          </span>
        ))}
      </div>
    </BlockShell>
  );
};

export default BlockCompliance;
